// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zdXD","inner":"Footer_inner__3pm3N","nextIcon":"Footer_nextIcon__1LgcG","innerLeft":"Footer_innerLeft__14jvY"};